// extracted by mini-css-extract-plugin
export default {"posted_by_main":"PostedBy_posted_by_main__ONSzE","postedby_heading":"PostedBy_postedby_heading__nvb2Y","user_details_container":"PostedBy_user_details_container__TOEVc"};